import { Link } from 'react-router-dom'
import ButtonSponsorsOptions from './ButtonSponsorsOptions'

export default function SponsorsGridItem({ sponsor }) {
  return (
    <div
      key={sponsor.id}
      className="col-span-12 flex flex-col bg-white md:col-span-6 lg:col-span-4 xl:col-span-3"
    >
      <div
        className={`relative flex flex-col border-2 ${sponsor.is_published === 1 ? 'bg-white' : 'bg-muted-300'} border-muted-500`}
      >
        <img
          alt={sponsor?.name_ar}
          src={`${process.env.REACT_APP_API_BASE_URL}/storage/flags/${sponsor.country.image}`}
          className="absolute left-0 top-0 h-14 w-14 object-contain pl-2 opacity-80"
        />
        <div className="p-2">
          <div className="text-sm font-bold">{sponsor.name_ar}</div>
          <div className="text-sm font-bold">{sponsor.country.name_ar}</div>
        </div>
        <div className="flex justify-between gap-2 border-t-2 p-2">
          <div className="flex">
            <Link
              to={`/sponsors/${sponsor.id}`}
              className="border-2 border-muted-500 bg-white p-2 hover:bg-muted-500"
            >
              تفاصيل الراعي
            </Link>
          </div>
          <ButtonSponsorsOptions sponsor={sponsor} />
        </div>
      </div>
    </div>
  )
}
